import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import _ from 'lodash';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Card,
    CardContent,
    Checkbox,
    Typography,
    Chip,
    Grid,
    List,
    ListItem,
    Divider,
    Collapse

} from '@material-ui/core';

// import config from '../../config/config.json'



const useStyles = makeStyles(theme => ({
    root: {
        padding: theme.spacing(3)
    },
    content: {
        marginTop: theme.spacing(2)
    },
    card: {
        width: '100%'
    }
}));

const UsersList = (props) => {
    const { className, ...rest } = props;
    const classes = useStyles();

    const [users, setUsers] = useState([]);



    useEffect(() => {
        // Поулчим списки сессий и пользователей
        // getData();
        // setUsers(prepareApiUsers(props.users))
        setUsers(props.users)
        // console.log('props.users',props.users);
    }, [props.users]);

    const handleChange = user => event => {
        // console.log('handleChange', event.target.checked, user);
        props.onChange(user, event.target.checked)
        // setChecked(event.target.checked);
    };

    const filterUsers = (couponStateFilterId, customerTypeFilterId) => {
        // console.log('couponStateFilterId,customerTypeFilterId',couponStateFilterId,customerTypeFilterId);
        return customerTypeFilter(couponStateFilter(props.users, couponStateFilterId), customerTypeFilterId)
        // console.log('handleChange', event.target.checked, user);
        // props.onChange(user,event.target.checked)
        // setChecked(event.target.checked);
    };

    const couponStateFilter = (usersNew, couponStateFilterId) => {
        // console.log('couponStateFilter usersNew,couponStateFilterI', usersNew,couponStateFilterId);
        switch (couponStateFilterId) {
            case 1:
                return _.filter(usersNew, (c) => { return c.coupon.amount > c.checkedCoupons.length })
            case 2:
                return _.filter(usersNew, (c) => { return c.coupon.amount <= c.checkedCoupons.length })
            case 3:
                return usersNew
        }


    };

    const customerTypeFilter = (usersNew, customerTypeFilterId) => {
        switch (customerTypeFilterId) {
            case 0:
                return _.filter(usersNew, (c) => { return c.user.type === 0 })
            case 1:
                return _.filter(usersNew, (c) => { return c.user.type === 1 })
            case 2:
                return usersNew
        }

    };

    const getColapseStae = (checked) => {
        // console.log('getColapseStae', checked, props.couponStateFilter);
        switch (props.couponStateFilter) {
            case 1:
                return checked ? true : false
            case 2:
                return checked ? false : true
            case 3:
                return true
        }

    }

    //   Изменение фильтров
    useEffect(() => {
        setUsers(filterUsers(props.couponStateFilter, props.customerTypeFilter))

        // setCouponStateFilter(props.couponStateFilter)
    }, [props.couponStateFilter, props.customerTypeFilter]);


    return (

        <Card
            //   {...rest}
            className={classes.card}
        >
            <CardContent className={classes.content}>
                <PerfectScrollbar>
                    <div className={classes.inner}>
                        <List dense={true}>
                            {_.sortBy(users, 'user.name').map(c => (
                                <React.Fragment
                                    key={c.coupon.id}
                                >

                                    <Collapse
                                        in={getColapseStae(c.allChecked)}
                                        timeout={{ exit: 400, enter: 400 }}
                                    >
                                        <React.Fragment>
                                            <ListItem>
                                                <Grid
                                                    container
                                                    direction="row"
                                                    justify="flex-start"
                                                    alignItems="center"
                                                    spacing={1}
                                                >
                                                    <Grid
                                                        item
                                                        xs={8}>
                                                        <Typography variant="h5" component="h2" style={c.coupon.amount <= c.checkedCoupons.length ? { textDecoration: 'line-through' } : {}}>
                                                            {c.user.name} {' '}
                                                            {
                                                                c.user.type === 1 &&
                                                                <Chip label="С" />
                                                            }
                                                        </Typography>


                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={4}>
                                                        <Grid
                                                            container
                                                            direction="row"
                                                            justify="flex-end"
                                                            alignItems="center"
                                                        >
                                                            {
                                                                c.couponsList.map(cl => (

                                                                    <Grid
                                                                        item
                                                                        key={cl.id}
                                                                    >
                                                                        <Checkbox
                                                                            edge="end"
                                                                            onChange={handleChange(cl)}
                                                                            checked={cl.checked}
                                                                        // inputProps={{ 'aria-labelledby': labelId }}
                                                                        />
                                                                    </Grid>
                                                                ))

                                                            }

                                                        </Grid>
                                                    </Grid>

                                                </Grid>

                                            </ListItem>
                                            <Divider component="li" />
                                        </React.Fragment>
                                    </Collapse>
                                </React.Fragment>
                            ))}


                        </List>
                    </div>
                </PerfectScrollbar>
            </CardContent>
        </Card>


    );
};

export default UsersList;